import Catalog from '../../views/Catalog';
import NotFound from '../../views/extrasSettings/NotFound';
import LoginSettings from '../../views/extrasSettings/LoginSettings';
import TaxRates from '../../views/extrasSettings/TaxRates';
import DashboardClients from '../../views/dashboard/DashboardClients';
import RoleEdit from '../../views/RoleEdit';
import RolesView from '../../views/Roles';
import ProcessWorkers from '../../views/system/ProcessWorkers';

export const globalSettingsRoutes = {
    ROUTE_HIDDEN_PROCESS_WORKERS: {
        id: 'ROUTE_HIDDEN_PROCESS_WORKERS',
        path: '/system/workers',
        type: 'hidden',
        exact: true,
        icon: 'fa fa-cogs',
        component: ProcessWorkers,
    },
    ROUTE_GLOBAL_SETTINGS_CATALOGUE_MODE: {
        id: 'ROUTE_GLOBAL_SETTINGS_CATALOGUE_MODE',
        path: '/globalSettings/catalog',
        type: 'globalSettings',
        exact: true,
        icon: 'cil-book',
        component: Catalog,
    },
    ROUTE_GLOBAL_SETTINGS_404: {
        id: 'ROUTE_GLOBAL_SETTINGS_404',
        path: '/globalSettings/notFound',
        type: 'globalSettings',
        exact: true,
        icon: 'fal fa-bug',
        component: NotFound,
    },
    ROUTE_GLOBAL_SETTINGS_TAX_RATES: {
        id: 'ROUTE_GLOBAL_SETTINGS_TAX_RATES',
        path: '/globalSettings/taxRates',
        type: 'globalSettings',
        exact: true,
        icon: 'cil-money',
        component: TaxRates,
    },
    ROUTE_GLOBAL_SETTINGS_LOGIN: {
        id: 'ROUTE_GLOBAL_SETTINGS_LOGIN',
        path: '/globalSettings/login',
        type: 'globalSettings',
        exact: true,
        icon: 'cil-lock-locked',
        component: LoginSettings,
    },
    ROUTE_GLOBAL_SETTINGS_USERS:
    {
        id: 'ROUTE_GLOBAL_SETTINGS_USERS',
        path: '#',
        type: 'globalSettings',
        exact: true,
        icon: 'fal fa-users',
        children:
        [
            {
                id: 'ROUTE_GLOBAL_SETTINGS_USERS_ACCOUNTS',
                path: '/dashboard/clients',
                exact: true,
                component: DashboardClients,
                icon: 'fal fa-users'
            },
            {
                id: 'ROUTE_GLOBAL_SETTINGS_USERS_ROLES',
                path: '/dashboard/roles',
                exact: true,
                component: RolesView,
                icon: 'fal fa-masks-theater'
            },
            {
                id: 'ROUTE_GLOBAL_SETTINGS_USERS_ROLE_EDIT',
                path: '/roles/:roleId/edit',
                exact: true,
                type: 'usersAndPermissions',
                icon: 'fal fa-user-cog',
                component: RoleEdit,
                hidden: true
            },
        ]
    }
};